<div class="ai-container">

  <!-- HEADER -->
  <header class="suite-header">
    <h2>AI Test Case Generator</h2>
    <p>Suite Name: <strong></strong></p>
  </header>

  <section class="steps-section" *ngIf="showStepsSection">
    <h3>Select Application Steps</h3>

    <div class="step-card" *ngFor="let step of testCaseSteps; let i = index">

      <label class="step-header">
        <input type="checkbox"
          [name]="'step_' + i"
          [(ngModel)]="step.selected"
          (change)="onStepSelectionChange(step)" />
        <span class="step-label">{{ step.path }}</span>
      </label>

      <div class="automation-scope-panel" *ngIf="step.selected">

        <div class="automation-scope-header">
          <span class="scope-title">Automation Context — Suite Hierarchy</span>
        </div>

        <div class="hierarchy-stats-bar">
          <span class="stat-chip pre-chip" [class.active]="getPreContextCount(step) > 0">
              PRE: {{ getPreContextCount(step) }} steps
          </span>
          <span class="stat-divider">|</span>
          <span class="stat-chip post-chip" [class.active]="getPostContextCount(step) > 0">
            POST: {{ getPostContextCount(step) }} steps
          </span>
        </div>

        <div class="no-steps-hint" *ngIf="step.suiteTree?.features?.length === 0">
          <span>No suite hierarchy available for this step</span>
        </div>

        <!-- SUITE TREE -->
        <div class="suite-tree" *ngIf="step.suiteTree?.features?.length > 0">

          <!-- Suite header -->
          <div class="tree-suite-header">
            <span class="tree-suite-name">{{ step.suiteTree.suiteName }}</span>
            <span class="suite-tc-note">TESTCASES WILL BE GENERATED FOR MAIN STEP</span>
          </div>

          <ng-container *ngFor="let feature of step.suiteTree.features; let fi = index">

            <!-- FEATURE ROW -->
            <div class="tree-row tree-row--feature"
                [class.pre-zone]="isFeatureBeforeStep(feature, step)"
                [class.post-zone]="isFeatureAfterStep(feature, step)"
                [class.mixed-zone]="isFeatureMixed(feature, step)">
              <span class="cell-badge">
                <span class="zone-badge pre-badge"  *ngIf="isFeatureBeforeStep(feature, step)">PRE</span>
                <span class="zone-badge post-badge" *ngIf="isFeatureAfterStep(feature, step)">POST</span>
              </span>
              <span class="cell-check">
                <input type="checkbox" class="tree-check"
                      *ngIf="isFeatureMixed(feature, step) || isFeatureBeforeStep(feature, step) || isFeatureAfterStep(feature, step)"
                      [name]="'feature_' + fi"
                      [checked]="isFeatureFullySelected(feature)"
                      [indeterminate]="isFeaturePartiallySelected(feature)"
                      (change)="onFeatureToggle(feature, step)" />
              </span>
              <span class="cell-name" (click)="toggleFeatureExpand(feature)">
                <span class="tree-expand-btn">{{ feature.expanded ? '▾' : '▸' }}</span>
                <span class="tree-feature-name">{{ feature.featureName }}</span>
              </span>
            </div>

            <ng-container *ngIf="feature.expanded">
              <ng-container *ngFor="let scenario of feature.scenarios">

                <div class="tree-row tree-row--scenario"
                    [class.pre-zone]="isScenarioBeforeStep(scenario, step)"
                    [class.post-zone]="isScenarioAfterStep(scenario, step)"
                    [class.mixed-zone]="isScenarioMixed(scenario, step)">
                  <span class="cell-badge">
                    <span class="zone-badge pre-badge"  *ngIf="isScenarioBeforeStep(scenario, step)">PRE</span>
                    <span class="zone-badge post-badge" *ngIf="isScenarioAfterStep(scenario, step)">POST</span>
                  </span>
                  <span class="cell-check">
                    <input type="checkbox" class="tree-check"
                          *ngIf="isScenarioBeforeStep(scenario, step) || isScenarioAfterStep(scenario, step) || isScenarioMixed(scenario, step)"
                          [checked]="isScenarioFullySelected(scenario)"
                          [indeterminate]="isScenarioPartiallySelected(scenario)"
                          (change)="onScenarioToggle(scenario, feature, step)" />
                  </span>
                  <span class="cell-name" (click)="toggleScenarioExpand(scenario)">
                    <span class="tree-expand-btn">{{ scenario.expanded ? '▾' : '▸' }}</span>
                    <span class="tree-scenario-name">{{ scenario.scenarioName }}</span>
                  </span>
                </div>

                <ng-container *ngIf="scenario.expanded">

                  <!-- STEP ROW -->
                  <div class="tree-row tree-row--step"
                      *ngFor="let s of scenario.steps"
                      [class.is-main-step]="s.step_id === step.step_id"
                      [class.pre-zone]="isStepBeforeMainStep(s, step)"
                      [class.post-zone]="isStepAfterMainStep(s, step)">
                    <span class="cell-badge">
                      <span class="zone-badge pre-badge"
                            *ngIf="isStepBeforeMainStep(s, step) && s.step_id !== step.step_id">PRE</span>
                      <span class="zone-badge post-badge"
                            *ngIf="isStepAfterMainStep(s, step) && s.step_id !== step.step_id">POST</span>
                      <span class="main-step-tag" *ngIf="s.step_id === step.step_id">MAIN</span>
                    </span>
                    <span class="cell-check">
                      <input type="checkbox" class="tree-check"
                            [(ngModel)]="s.selectedForAutomation"
                            [disabled]="s.step_id === step.step_id"
                            (change)="onStepToggle(s, scenario, feature, step)" />
                    </span>
                    <span class="cell-name">
                      <span class="tree-step-name"
                            [class.main-step-label]="s.step_id === step.step_id">
                        {{ s.step_name }}
                      </span>
                    </span>
                  </div>

                </ng-container>
              </ng-container>
            </ng-container>

          </ng-container>
        </div>
        <!-- /suite-tree -->

        <div class="scope-warning"
             *ngIf="getPostContextCount(step) > 0 && getPreContextCount(step) === 0">
          ⚠️ POST steps selected without PRE steps — automation may fail if POST depends on earlier state.
        </div>

      </div>
    </div>

    <textarea name="summaryText"
          placeholder="Optional description for AI"
          [(ngModel)]="summaryText"
          [featureActionState]="'AI_TESTCASE_GENERATION'"></textarea>

    <button class="primary-btn"
      (click)="generateTestCases()"
      [featureActionState]="'AI_TESTCASE_GENERATION'"
      [disabled]="isGenerating || !hasSelectedSteps()">
      <span *ngIf="!isGenerating">Generate Test Cases</span>
      <span *ngIf="isGenerating">Generating...</span>
    </button>
  </section>

  <!-- TABLE SECTION -->
  <section class="table-section" *ngIf="showTableSection">
    <div class="table-filter-bar">
      <input type="text" placeholder="Search Test Case"
        [(ngModel)]="searchText" (ngModelChange)="applyFilter()" />
      <button class="primary-btn" *ngIf="showGenerateAutomationButton" [featureActionState]="'AI_TESTCASE_GENERATION'" (click)="generateAutomation()">Generate Automation</button>
      <button class="primary-btn" *ngIf="!showGenerateAutomationButton" (click)="runAll()" [disabled]="!hasSelectedTestCases()" [featureActionState]="'AI_TESTCASE_GENERATION'">{{ getRunButtonText() }}</button>
      <button class="delete-btn" *ngIf="!showGenerateAutomationButton" [featureActionState]="'AI_TESTCASE_GENERATION'" (click)="deleteSelectedTestCases()" [disabled]="!hasSelectedTestCases()">{{ getDeleteButtonText() }}</button>
      <button class="primary-btn" [featureActionState]="'AI_TESTCASE_GENERATION'"(click)="saveToLibrary()" [disabled]="!hasSelectedTestCases() || isSavingToLibrary">{{ isSavingToLibrary ? 'Saving...' : 'Save in Library' }}</button>
    </div>
    <div class="table-container">
      <div class="table-scroll">
        <table class="testcase-table">
          <thead>
            <tr>
              <th class="checkbox"><input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()" [featureActionState]="'AI_TESTCASE_GENERATION'"/></th>
              <th>ID</th><th>Description</th><th>Steps</th>
              <th *ngIf="!showGenerateAutomationButton">Artifact</th>
              <th>Test Data</th><th>Expected</th>
              <th *ngIf="!showGenerateAutomationButton" class="center">Execute</th>
              <th *ngIf="!showGenerateAutomationButton">Report</th>
              <th *ngIf="!showGenerateAutomationButton" class="center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tc of filteredTestCases; let i = index"
              [class.editing-row]="editingIndex === i" [class.selected]="tc.selected">
              <td class="checkbox"><input type="checkbox" [(ngModel)]="tc.selected" (change)="onCheckboxChange()" [featureActionState]="'AI_TESTCASE_GENERATION'" /></td>
              <td class="id">
                <span *ngIf="editingIndex !== i">{{ tc.test_case_id }}</span>
                <input *ngIf="editingIndex === i" class="table-input" [(ngModel)]="editableRow.test_case_id" name="edit-id-{{i}}" autofocus />
              </td>
              <td>
                <span *ngIf="editingIndex !== i"
                      class="tooltip-cell description-tooltip"
                      [attr.data-tooltip]="tc.description || tc.test_case"
                      (mouseenter)="onTooltipEnter($event)"
                      (mouseleave)="onTooltipLeave($event)">
                  {{tc.description || tc.test_case}}
                </span>
                <input *ngIf="editingIndex === i" class="table-input" [(ngModel)]="editableRow.description" name="edit-desc-{{i}}" />
              </td>
              <td class="steps-column">
                <div *ngIf="editingIndex !== i" class="steps-scroll">
                  <ol>
                    <li *ngFor="let step of tc.test_steps">{{ step }}</li>
                  </ol>
                </div>
                <div *ngIf="editingIndex === i">
                  <textarea class="table-textarea" name="edit-steps-{{i}}"
                    [(ngModel)]="editableRow.test_stepsText" rows="6"></textarea>
                </div>
              </td>
              <td *ngIf="!showGenerateAutomationButton">
                <span class="artifact-link" (click)="openArtifactInCanvas(tc)" [title]="tc.suite_name" [featureActionState]="'AI_TESTCASE_GENERATION'">{{ tc.suite_name }}</span>
              </td>
              <td class="center">
                <span *ngIf="hasTestData(tc.test_data)" class="test-data-link" (click)="openTestDataDialog(tc)">View Test Data</span>
                <span *ngIf="!hasTestData(tc.test_data)" class="no-data">No Data</span>
              </td>
              <td class="expected-column">
                <span *ngIf="editingIndex !== i"
                      class="tooltip-cell expected-tooltip truncated-text"
                      [attr.data-tooltip]="tc.expected_result"
                      (mouseenter)="onTooltipEnter($event)"
                      (mouseleave)="onTooltipLeave($event)">
                  {{ tc.expected_result }}
                </span>
                <textarea *ngIf="editingIndex === i"
                          class="table-textarea"
                          name="edit-expected-{{i}}"
                          [(ngModel)]="editableRow.expected_result"
                          rows="2"></textarea>
              </td>
              <td *ngIf="!showGenerateAutomationButton" class="center">
                <button class="run-test-btn" (click)="runSingle(tc)" [featureActionState]="'AI_TESTCASE_GENERATION'">Run</button>
              </td>
              <td *ngIf="!showGenerateAutomationButton" class="center">
                <button class="view-report-btn" (click)="openReport(tc)"
                  [disabled]="!tc.last_run_report_id"
                  [style.opacity]="tc.last_run_report_id ? '1' : '0.4'"
                  [style.cursor]="tc.last_run_report_id ? 'pointer' : 'not-allowed'">View</button>
              </td>
              <td *ngIf="!showGenerateAutomationButton" class="center">
                <div class="action-buttons">
                  <button *ngIf="editingIndex === i"  class="icon-btn save"  [featureActionState]="'AI_TESTCASE_GENERATION'" (click)="saveEdit(i)">💾</button>
                  <button *ngIf="editingIndex === i"  class="icon-btn cancel"[featureActionState]="'AI_TESTCASE_GENERATION'" (click)="cancelEdit()">✖</button>
                  <button *ngIf="editingIndex !== i"  class="icon-btn edit"   [featureActionState]="'AI_TESTCASE_GENERATION'" (click)="editRow(i)">✎</button>
                  <button *ngIf="editingIndex !== i"  class="icon-btn delete" [featureActionState]="'AI_TESTCASE_GENERATION'" (click)="deleteSingleTestCase(tc, i)">🗑</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <div class="loading-overlay" *ngIf="isGenerating">
    <div class="loading-content">
      <div class="spinner"></div>
      <p class="loading-message">Generating test cases...</p>
      <p class="loading-submessage">{{ loadingSubmessage }}</p>
    </div>
  </div>
</div>